function initLogoGimmick() {
  if(window.theme.customer.is_logged_in) {
    let loggedStatus = window.sessionStorage.getItem("isLoggedIn");

    if(loggedStatus >= 1 && !window.location.pathname.includes('account')) {      
      window.sessionStorage.setItem("isLoggedIn", true);

      // Run gimmick
      setTimeout(function() {
        document.querySelector(".header__logo-image .etiql-logo").style.transform = "translateX(-50%) translateY(-50px)";
      }, 1250)
    
      setTimeout(function() {
        document.querySelector(".header__logo-image .customer").style.transform = "translateY(0)";
      }, 1500)
    
      setTimeout(function() {
        document.querySelector(".header__logo-image .etiql-logo").style.opacity = "0";
        document.querySelector(".header__logo-image .etiql-logo").style.transform = "translateX(-50%) translateY(50px)";
      }, 5500)
    
      setTimeout(function() {
        document.querySelector(".header__logo-image .customer").style.transform = "translateY(-50px)";
      }, 15500)
    
      setTimeout(function() {
        document.querySelector(".header__logo-image .etiql-logo").style.opacity = "1";
        document.querySelector(".header__logo-image .etiql-logo").style.transform = "translateX(-50%) translateY(0)";
      }, 15750)
    }
  } else {
    // console.log("not logged in")
    let loggedStatus = window.sessionStorage.getItem("isLoggedIn");

    if(loggedStatus != 0) {
      window.sessionStorage.setItem("isLoggedIn", 1);
    } else {
      window.sessionStorage.setItem("isLoggedIn", loggedStatus++);
    }
  }

  // console.log("isLoggedIn", window.sessionStorage.getItem("isLoggedIn"))
}

document.addEventListener("DOMContentLoaded", (event) => {
  initLogoGimmick();
});
